<template>
  <div class="mt-1 dropdown-content" :class="classes">
    <ul>
      <li @click="copyUrlSrc">
        <p v-if="!show" style="color: gray;" class="d-inline">
            Copy Link <font-awesome-icon size="lg" icon="copy"/>
        </p>
        <p v-if="show" style="color: green;" class="d-inline">
            Copied! <font-awesome-icon size="lg" icon="check-circle"/>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      urlSource: String,
      classes: {
        type: String,
        default: null,
      },
      copyHandlerComplete: {
        type: Function,
        default: () => {},
      }
    },
    data() {
      return {
        show: false,
      }
    },
    methods: {
      copyUrlSrc() {
          this.show = true;
          navigator.clipboard.writeText(this.urlSource)
          .catch(() => {
              console.log(`Unable to copy "${this.urlSource}" to clipboard`);
          })
          .finally(() => {
              setTimeout(() => {
                  this.show = false;
                  this.copyHandlerComplete();
              }, 3000);
          });
      },
    }
  }
</script>